module.exports = __webpack_public_path__ + "static/media/MentoringNew.6339d79b.png";